module.exports = __webpack_public_path__ + "static/media/ranqiguolu.a42aade1.png";